const STEPS = [
  {
    letter: "S",
    title: "See the Seed",
    body: "Recognize the potential in every student, educator, and community member.",
  },
  {
    letter: "O",
    title: "Observe the Obstacles",
    body: "Name what's blocking growth — honestly. Systems, relationships, expectations.",
  },
  {
    letter: "I",
    title: "Intentions with Integrity",
    body: "Align actions with values and purpose. The plan must match the promise.",
  },
  {
    letter: "L",
    title: "Lead How You Live",
    body: "Become the example. Influence is downstream of how you show up every day.",
  },
];

export default function Framework() {
  return (
    <section id="framework" className="relative bg-mist py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="eyebrow text-gold">Signature Framework</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-3 font-bold tracking-tight">
            The <span className="italic font-medium">S.O.I.L.</span> Framework
          </h2>
          <p className="mt-5 text-[15px] text-navy/65 leading-relaxed">
            Growth doesn&apos;t happen by accident. It happens in the right soil — a four-part
            method to shape the environment where outcomes take root.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {STEPS.map((s) => (
            <div
              key={s.letter}
              data-testid={`soil-step-${s.letter}`}
              className="bg-white border border-[hsl(var(--line))] p-6 hover:border-navy/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-baseline gap-3">
                <span className="font-serif text-5xl text-gold leading-none font-bold">
                  {s.letter}
                </span>
                <span className="h-px flex-1 bg-[hsl(var(--line))]" />
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mt-5 leading-tight">
                {s.title}
              </h3>
              <p className="mt-2 text-[13.5px] text-navy/65 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
